import type { MutableRefObject } from 'react';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, theme } from 'antd';
import { useJobStatusBgColor } from 'pos-client/components/scheduleBoard/hooks/useJobStatusColourMapper.ts';
import { useJobStatusTextColor } from 'pos-client/components/scheduleBoard/hooks/useJobStatusTextColor.ts';
import { durationToMinutes } from 'pos-client/utils/dateHelpers.ts';
import type { ScheduleBoardJobModel } from 'pos-shared/models/schedulingSchema.ts';

import { JobSlotContent } from './JobSlotContent.tsx';
import { JobSlotTooltip } from './JobSlotTooltip.tsx';

interface JobSlotProps {
  jobData: ScheduleBoardJobModel;
  targetChildRef: MutableRefObject<HTMLDivElement | null>;
  isInConflict: boolean;
  isDefaultLane: boolean;
  userIsDragging: boolean;
}

export const JobSlot = ({
  jobData,
  targetChildRef,
  isInConflict,
  isDefaultLane,
  userIsDragging,
}: JobSlotProps) => {
  const { token } = theme.useToken();
  const textColor = useJobStatusTextColor(
    !isDefaultLane && isInConflict ? 'conflict' : jobData.state
  );
  const bgColor = useJobStatusBgColor(jobData.state);
  const jobDurationInMinutes = durationToMinutes(jobData.duration);

  return (
    <JobSlotTooltip
      appointmentData={jobData}
      placement="rightTop"
      isInConflict={!isDefaultLane && isInConflict}
      userIsDragging={userIsDragging}
    >
      <Row
        ref={targetChildRef}
        style={{
          padding: token.paddingXS,
          backgroundColor: bgColor,
          backgroundSize: 'cover',
          color: textColor,
          width: '100%',
          height: '100%',
        }}
      >
        <JobSlotContent
          isInConflict={!isDefaultLane && isInConflict}
          jobData={jobData}
        />
        {jobDurationInMinutes && jobDurationInMinutes > 15 && (
          <Row
            align="middle"
            justify="center"
            className="job-slot__expand-icon"
            style={{
              width: 16,
              height: 16,
              fontSize: 10,
              border: `1px solid ${textColor}`,
              color: textColor,
              borderRadius: '50%',
              position: 'absolute',
              top: -8,
              left: '50%',
              transform: 'translateX(-50%)',
              background: bgColor,
              zIndex: 20,
            }}
          >
            <FontAwesomeIcon icon={faPlus} />
          </Row>
        )}
      </Row>
    </JobSlotTooltip>
  );
};
